export function validateNumberRange(value: number, min: number, max: number) {
  if (value < min || value > max) {
    return false;
  }
  return true;
}

export function getSaveTitle(hasChanged: boolean, rangeErr: string) {
  if (!hasChanged && !rangeErr) {
    return 'No changes to save';
  }

  if (hasChanged && !rangeErr) {
    return 'Save changes';
  }

  return 'Number is out of range';
}
